import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useState, useEffect, FormEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from '../../../enums';
import {
  useStripeCheckoutCardPaymentFormEffect,
  StripeCheckoutCardPaymentFormFields,
} from '../../../forms';
import { CardNumberElement } from '@stripe/react-stripe-js';
import {
  customerSlice,
  StoreState,
  useClearCartEffect,
  useGetCartFetchByClientIdEffect,
} from '../../../services';

export const useStripeCheckoutCardPaymentEffect = () => {
  const { members, getFieldValues } = useStripeCheckoutCardPaymentFormEffect();

  const [success, setSucceeded] = useState(false);
  const [error, setError] = useState<any | null>(null);
  const [processing, setProcessing] = useState<any | null>(null);
  const [clientSecret, setClientSecret] = useState('');
  const [disabled, setDisabled] = useState(true);
  const stripe = useStripe();
  const dispatch = useDispatch();
  const elements = useElements();
  const { converted } = useSelector(
    (state: StoreState) => state.customers.customer
  );
  const cartState = useSelector((state: StoreState) => state.orders.cart);
  const { cart, includesTrial, includesDoctor } = cartState;
  const { clearCart } = useClearCartEffect(Route.PATIENT_WELCOME_CONGRATS);
  if (cart) {
    useGetCartFetchByClientIdEffect(cart).then(() => null);
  }
  useEffect(() => {
    if (converted) {
      clearCart();
    }

    if (success) {
      dispatch(customerSlice.actions.checkout(cartState));
    }

    if (cart?.fetched) {
      setClientSecret(cart?.fetched?.paymentIntentClientSecret as string);
    }
  }, [
    success,
    cart,
    cartState,
    dispatch,
    converted,
    includesTrial,
    includesDoctor,
  ]);

  const onChange = async (event: any) => {
    setDisabled(event.empty);
    setError(event.error ? event.error.message : '');
  };

  const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setProcessing(true);

    const form = getFieldValues() as StripeCheckoutCardPaymentFormFields;

    const payload = await stripe?.confirmCardPayment(clientSecret, {
      payment_method: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        card: elements?.getElement(CardNumberElement),
        billing_details: {
          name: form.cardHolderName as string,
        },
      },
    });

    if (payload?.error) {
      setError(`Payment failed: ${payload.error.message}`);
      setProcessing(false);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true);
    }
  };

  return {
    members,
    processing,
    disabled,
    success,
    error,
    onChange,
    onSubmit,
  };
};
